module.exports = __webpack_public_path__ + "img/10.5c4d9812.svg";